// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "heatbrain-" + (chunkId === 8592 ? "common" : chunkId) + ".js";
};